import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Home.css';
import './css/Fonts.css';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import image from './img/backgroundMountainDarkCropped.jpg';
import ClientLogos from './ClientLogos';
import { products } from '../content';

function Home() {
  return (
    <div className="home">
      <section className="hero" style={{ backgroundImage: `url(${image})` }}>
        <Container className="hero-inner">
          <p className="hero-eyebrow">Data and applications for mining operations</p>
          <h1 className="hero-title">
            The right data from pit to plant, 
            <br />
            in one place.
          </h1>
          <p className="hero-sub">
            InfoRight helps mining companies collect, integrate, and use information from 
            your separate, disparate systems — so you can measure and improve 
            every process from extraction to transport to processing to refining.
          </p>
          <div className="hero-actions">
            <Button variant="" as={Link} to="/products" className="btn-primary-ir">
              Explore Products
            </Button>
            <Button variant="" as={Link} to="/contact" className="btn-ghost-ir">
              Request a Demo
            </Button>
          </div>
        </Container>
      </section>

      <ClientLogos />

      <section className="problem">
        <Container>
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <h2 className="section-title">Still running on spreadsheets and paper?</h2>
              <p className="section-lead">
                Spreadsheets and paper-based processes quietly become the most expensive system you
                own. Version control problems cost real money in delayed approvals and decisions
                made on stale numbers.
              </p>
              <p className="section-lead">
                Paper inspections can be lost or filled in later with incorrect numbers.
                Manual processes delay approvals, maintenance, and reporting.
              </p>
              <p className="section-lead">
                We help you replace spreadsheets and paper-based processes with an actual solution.
              </p>
              <Button variant="" as={Link} to="/services" className="btn-primary-ir mt-3">
                See How We Help
              </Button>
            </Col>
            <Col lg={6}>
              <div className="contrast-card">
                <div className="contrast-row">
                  <span className="contrast-label contrast-before">Before</span>
                  <span>Inspection sheets in a truck, filled in days later</span>
                </div>
                <div className="contrast-row">
                  <span className="contrast-label contrast-before">Before</span>
                  <span>Ore and waste data tracked across 6 sheets or workbooks</span>
                </div>
                <div className="contrast-row">
                  <span className="contrast-label contrast-before">Before</span>
                  <span>Certifications tracked in a binder</span>
                </div>
                <div className="contrast-divider" />
                <div className="contrast-row">
                  <span className="contrast-label contrast-after">After</span>
                  <span>Defects reach maintenance the moment they are found</span>
                </div>
                <div className="contrast-row">
                  <span className="contrast-label contrast-after">After</span>
                  <span>Every load trackable and totalizable on demand</span>
                </div>
                <div className="contrast-row">
                  <span className="contrast-label contrast-after">After</span>
                  <span>MSHA documentation produced on demand</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="suites">
        <Container>
          <h2 className="section-title text-center">A full suite, built for mining</h2>
          <p className="section-lead text-center mx-auto suites-lead">
            A suite of safety and inspection applications with routing, approvals, and notifications.
          </p>
          <Row className="g-4 mt-2 justify-content-center">
            <Col md={6}>
              <div className="suite-card">
                <h3 className="suite-card-title">Safety &amp; Inspection</h3>
                <p className="suite-card-text">
                  Pre-op vehicle inspections, area and water compliance inspections, visitor
                  training approval, and MSHA certification management — all capturing usable data
                  in the field.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="product-preview">
        <Container>
          <h2 className="section-title text-center">Our solutions</h2>
          <Row className="g-4 mt-2">
            {products.map((product) => (
              <Col md={6} lg={4} key={product.id}>
                <Card className="preview-card h-100">
                  <Card.Body>
                    <Card.Title className="preview-card-title">{product.name}</Card.Title>
                    <Card.Text className="preview-card-text">{product.tagline}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
            <Col md={6} lg={4}>
              <Link to="/products" className="preview-card preview-card-link h-100">
                <span>See all products</span>
                <span className="preview-arrow" aria-hidden="true">→</span>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="cta-band">
        <Container className="text-center">
          <h2 className="cta-title">Ready to see it on your data?</h2>
          <p className="cta-text">
            We work with you to achieve meaningful results as quickly as possible.
          </p>
          <Button variant="" as={Link} to="/contact" className="btn-light-ir">
            Request a Demo
          </Button>
        </Container>
      </section>
    </div>
  );
}

export default Home;
